import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgDeviceMobile = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.25 1.75H8.75a2.625 2.625 0 0 0-2.625 2.625v19.25A2.625 2.625 0 0 0 8.75 26.25h10.5a2.625 2.625 0 0 0 2.625-2.625V4.375A2.625 2.625 0 0 0 19.25 1.75ZM7.875 7h12.25v14H7.875V7Zm.875-3.5h10.5a.875.875 0 0 1 .875.875v.875H7.875v-.875A.875.875 0 0 1 8.75 3.5Zm10.5 21H8.75a.875.875 0 0 1-.875-.875v-.875h12.25v.875a.875.875 0 0 1-.875.875Z" />
  </svg>
);
export default SvgDeviceMobile;
